import React from "react";

const caseStudies = [
  {
    title: "Enterprise Support & Engineering Shield",
    summary:
      "Reduced engineering escalations by 50% by improving triage quality, reproduction steps, code-level investigation, documentation, and direct PR fixes.",
    tags: [
      "enterprise support",
      "debugging",
      "SDK/API triage",
      "PR fixes",
      "engineering handoff",
    ],
  },
  {
    title: "AI Moderation Reporting Automation",
    summary:
      "Replaced manual reporting workflows with scheduled data pipelines and a live dashboard, moving monthly reporting from days of manual work to automated reporting.",
    tags: [
      "BigQuery",
      "Looker Studio",
      "automation",
      "reporting",
      "production operations",
    ],
  },
  {
    title: "Solution Design Documentation Workflow",
    summary:
      "Built an internal documentation workflow that helped technical teams create standardized solution design documents with API references, diagrams, and formatting in minutes instead of days.",
    tags: [
      "solution design",
      "documentation",
      "API references",
      "technical enablement",
      "delivery quality",
    ],
  },
];

const Projects = () => {
  return (
    <section id="case-studies" className="pt-16">
      <div className="mb-6">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-sky-600">
          Case Studies
        </p>
        <h2 className="mt-2 text-2xl font-bold text-slate-950">
          Solution engineering impact
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600">
          Anonymous examples from enterprise SaaS, implementation support, and
          internal automation work.
        </p>
      </div>

      <div className="grid gap-4">
        {caseStudies.map((study) => (
          <article
            className="rounded-lg border border-slate-200 bg-white/70 p-5 shadow-sm"
            key={study.title}
          >
            <h3 className="text-lg font-semibold text-slate-950">
              {study.title}
            </h3>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              {study.summary}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {study.tags.map((tag) => (
                <span
                  className="rounded-full border border-slate-200 bg-white/75 px-3 py-1 text-xs font-medium text-slate-600"
                  key={tag}
                >
                  {tag}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
